"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _authModule = _interopRequireDefault(require("./auth.module.scss"));
var _constant = require("./constant");
var _ = require("../..");
var _logo = _interopRequireDefault(require("./logo.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ArcLogin = function ArcLogin(_ref) {
  var handleFinish = _ref.handleFinish,
    handleForgotPassword = _ref.handleForgotPassword,
    isLoader = _ref.isLoader,
    bGImage = _ref.bGImage;
  var _Form$useForm = _.Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].bgImageCls
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].login
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_authModule["default"].formWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].header
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _logo["default"],
    size: {
      height: 70,
      width: 108
    },
    width: 108,
    height: 70
  })), /*#__PURE__*/_react["default"].createElement("h6", null, "Welcome Back"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(_authModule["default"].small, " small")
  }, "Manage your product and inventory as well"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].formData
  }, /*#__PURE__*/_react["default"].createElement(_.ArcForm, {
    fields: _constant.LOGINFORM,
    tabIndex: 0,
    form: form,
    onFinish: handleFinish,
    onPressEnter: true,
    formName: "login"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].signUpOptions
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].line
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].otherOptions
  }, "Sign in with"), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleForgotPassword,
    className: _authModule["default"].forgot
  }, "Forgot Password?")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].signupBtn
  }, /*#__PURE__*/_react["default"].createElement(_.ArcButton, {
    loading: isLoader,
    onClick: function onClick() {
      return form.submit();
    },
    type: 'primary',
    label: 'sign in'
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].banner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].slider
  }, /*#__PURE__*/_react["default"].createElement("div", null, bGImage), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].footer
  }, /*#__PURE__*/_react["default"].createElement("h6", null, "Manage your product, inventory, pricing & promotion"), /*#__PURE__*/_react["default"].createElement("span", null, "A unified experience hub for modern retailers to build and manage unique digital experiences and provide seamless shopping experience for consumers"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].dots
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].active
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].circle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].circle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].circle
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].bgImageRight
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _authModule["default"].bgImageRight2
  }));
};
var _default = ArcLogin;
exports["default"] = _default;